import {
  FC, useEffect, useState, 
} from 'react';

import { toHHMMSS } from 'utils/helpers';

interface ITimerProps {
  seconds?: number;
  callback: () => void;
}

const Timer: FC<ITimerProps> = ({ seconds = 60, callback }) => {
  const [currentSeconds, setCurrentSeconds] = useState(seconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSeconds((pervSeconds) => {
        if (pervSeconds > 0) {
          return --pervSeconds;
        } else {
          clearInterval(timer);
          callback && callback();
        }

        return pervSeconds;
      });
    }, 1000);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [seconds]);

  return <span className='ml-1'>{toHHMMSS(currentSeconds)}</span>;
};

export default Timer;